const TOAST_STYLES = {
  info: { bg: '#4a90e2', color: '#ffffff' },
  success: { bg: '#4caf50', color: '#ffffff' },
  warn: { bg: '#ffc107', color: '#1a1a1a' },
  error: { bg: '#e74c3c', color: '#ffffff' },
}

const MAX_QUEUE = 3
const queue = []
let container = null

function ensureContainer() {
  if (container && document.body.contains(container)) return container
  container = document.createElement('div')
  container.setAttribute('data-tm-toast-container', '')
  container.style.cssText = [
    'position:fixed',
    'top:env(safe-area-inset-top,8px)',
    'right:8px',
    'z-index:9999',
    'display:flex',
    'flex-direction:column',
    'gap:8px',
    'pointer-events:none',
    'max-width:calc(100vw - 16px)',
  ].join(';')
  document.body.appendChild(container)
  return container
}

function renderToast(message, options) {
  const host = ensureContainer()
  const { type = 'info', durationMs = 1500 } = options || {}
  const style = TOAST_STYLES[type] || TOAST_STYLES.info
  const el = document.createElement('div')
  el.setAttribute('data-tm-toast', '')
  el.textContent = message
  el.style.cssText = [
    'pointer-events:auto',
    `background:${style.bg}`,
    `color:${style.color}`,
    'font-family:"Quicksand","Nunito",system-ui,sans-serif',
    'font-size:16px',
    'font-weight:600',
    'padding:10px 14px',
    'border-radius:12px',
    'box-shadow:0 4px 12px rgba(26,26,26,.25)',
    'opacity:0',
    'transform:translateY(-6px)',
    'transition:opacity .2s ease,transform .2s ease',
    'max-width:320px',
    'word-break:break-word',
  ].join(';')
  host.appendChild(el)
  requestAnimationFrame(() => {
    el.style.opacity = '1'
    el.style.transform = 'translateY(0)'
  })
  const remove = () => {
    el.style.opacity = '0'
    el.style.transform = 'translateY(-6px)'
    setTimeout(() => el.remove(), 220)
  }
  setTimeout(remove, durationMs)
}

export function showToast(message, options = { type: 'info', durationMs: 1500 }) {
  if (queue.length >= MAX_QUEUE) {
    const oldest = queue.shift()
    oldest?.remove?.()
  }
  renderToast(message, options)
}
